<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月22日 11:02:34 +0800
 * @最后修改时间: 2020-10-27 15:17:14
 * @FilePath: /mrc_ess_web_fronted/src/Page/EssAdmin/Roster/RosterRecord/components/DateSelect.vue
 -->
<template>
  <v-container
    fluid
    class="
      fill-height
      max-width
      pa-0
      d-flex
      flex-row flex-grow-1
      justify-space-between
    "
  >
    <div class="max-width text-start pl-2">
      <div :class="year.indexOf('-') != -1 ? 'caption' : 'body-2'">
        {{ year }}
      </div>
      <div class="title font-weight-black text-block text-truncate">
        {{ month }}
        <!-- 2020-10-16 mel 去掉綠色的點 -->
        <!-- <span class="green--text material-icons-round md-18">brightness_1</span> -->
      </div>
      <div class="max-width d-flex mt-1">
        <v-checkbox
          v-model="checked"
          :ripple="false"
          v-if="isEdited"
          :color="isHalf ? 'grey' : ''"
          :readonly="false"
          style="pointer: cursor"
          :indeterminate="isHalf"
          class="mt-0 pt-0 ml-n1"
        ></v-checkbox>

        <span>{{
          $t("label_essweb_RosterFormRecord_form_table_staffNameLabbel")
        }}</span>
        <v-spacer></v-spacer>
        <v-btn icon v-if="0">
          <span class="material-icons-round">more_vert</span>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "DateSelect",
  props: {
    startTime: { default: "", type: String },
    endTime: { default: "", type: String },
    selectStaffs: { default: [], type: Array },
    allStaffs: { default: [], type: Array },
    isEdited: { default: false, type: Boolean },
  },
  computed: {
    isHalf() {
      if (this.selectStaffs.length == 0) {
        return false;
      } else {
        if (this.selectStaffs.length < this.allStaffs.length) {
          return true;
        }
        if (this.selectStaffs.length == this.allStaffs.length) {
          this.checked = true;
          return false;
        }
      }
    },
    year() {
      if (this.startTime && this.endTime) {
        if (dayjs(this.startTime).year() == dayjs(this.endTime).year()) {
          return dayjs(this.startTime).year().toString();
        } else {
          return (
            dayjs(this.startTime).year() + " - " + dayjs(this.endTime).year()
          );
        }
      } else {
        return "";
      }
    },
    month() {
      if (this.startTime && this.endTime) {
        const startM = dayjs(this.startTime).month();
        const endM = dayjs(this.endTime).month();
        if (startM === endM) {
          return this.$t(this.getMonthKey(startM + 1));
        } else {
          return (
            this.$t(this.getMonthKey(startM + 1)) +
            " - " +
            this.$t(this.getMonthKey(endM + 1))
          );
        }
      } else {
        return "";
      }
    },
  },
  watch: {
    checked(val) {
      this.$emit("onCheckAll", val);
    },
  },
  data() {
    return { checked: false };
  },
  methods: {
    getMonthKey: function (month) {
      switch (Number(month)) {
        case 1:
          return "label_essweb_system_JanuaryLabel";
          break;
        case 2:
          return "label_essweb_system_FebruaryLabel";
          break;
        case 3:
          return "label_essweb_system_MarchLabel";
          break;
        case 4:
          return "label_essweb_system_AprilLabel";
          break;
        case 5:
          return "label_essweb_system_MayLabel";
          break;
        case 6:
          return "label_essweb_system_JuneLabel";
          break;
        case 7:
          return "label_essweb_system_JulyLabel";
          break;
        case 8:
          return "label_essweb_system_AugustLabel";
          break;
        case 9:
          return "label_essweb_system_SeptemberLabel";
          break;
        case 10:
          return "label_essweb_system_OctoberLabel";
          break;
        case 11:
          return "label_essweb_system_NovemberLabel";
          break;
        case 12:
          return "label_essweb_system_DecemberLabel";
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped></style>
